import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import { getExercises, resetField } from "../../../store/actions";
import ExerciseHeader from "./exerciseHeader";
import ExerciseCard from "./exerciseCard";
import Loader from "../../../sharedComponents/preloader";
import FilterPanel from "../../../sharedComponents/filterPanel";
import AdvancedFilterPanel from "./advancedFilterPanel";
import NoExerciseImage from "../../../assets/images/no-recipes-found.png";
import { objToQueryString, queryStringToJSON } from "../../../utils/common";

const ExerciseListing = ({ getExercises, exerciseList, next, atBottom, history, resetField, exercisesSearchKeyword }) => {
	const [exercises, setExercises] = useState([]);
	const [loading, setLoading] = useState(true);
	const [showLoader, setShowLoader] = useState(true);
	const [fetching, setFetching] = useState(false);

	const [showAdvancedFilterPanel, setShowAdvancedFilterPanel] = useState(false);

	const [filters, setFilters] = useState({ limit: 30, name: "" });
	const [query, setQuery] = useState();

	useEffect(() => {
		setQuery(objToQueryString(filters));
	}, [filters]);

	useEffect(() => {
		if (query) {
			setExercises([]);
			setShowLoader(true);
			getExercises(`?${query}`);
		}
	}, [query, getExercises]);

	useEffect(() => {
		setLoading(true);
		exercisesSearchKeyword &&
			setFilters((prevState) => ({ ...prevState, ...queryStringToJSON(`?${exercisesSearchKeyword}`) }));
	}, [exercisesSearchKeyword]);

	useEffect(() => {
		setExercises((prevState) => {
			if (exerciseList !== null && exerciseList.length === 0) {
				setLoading(false);
			}
			return [...prevState, ...(exerciseList !== null ? exerciseList : [])];
		});
	}, [exerciseList]);

	useEffect(() => {
		exercises && exercises.length && setShowLoader(false);
	}, [exercises]);

	useEffect(() => {
		if (atBottom) {
			setFetching(next ? true : false);
			setLoading(next ? true : false);
		}
	}, [atBottom, next]);

	useEffect(() => {
		fetching && getExercises(`?${next.split("?")[1]}`);
		fetching && setShowLoader(true);
		setFetching(false);
	}, [fetching, getExercises, next]);

	useEffect(() => {
		return () => {
			resetField("Exercises.exercisesResult", {});
		};
	}, [resetField]);

	const submitFilter = (values) => {
		setShowAdvancedFilterPanel(false);
		setFilters({ ...values, limit: filters.limit, name: filters.name });
	};

	return (
		<section className="page page-exercise-list">
			<div className="container">
				<ExerciseHeader toggleAdvancedFilterPanel={() => setShowAdvancedFilterPanel(!showAdvancedFilterPanel)} />
				<div className="card-wrap">
					{exercises && exercises.length
						? exercises.map((card, i) => (
								<ExerciseCard key={i} cardInfo={card} history={history} forceEnable={true} />
						  ))
						: null}

					{loading ? (
						<Loader show={showLoader} />
					) : (
						exercises.length === 0 && (
							<div className="alert alert-info text-center w-100 m-3 no-exercises-found">
								<img src={NoExerciseImage} alt="No exercises found" />
								<div>No exercises found!</div>
							</div>
						)
					)}
				</div>
			</div>
			<FilterPanel
				show={showAdvancedFilterPanel}
				toggle={() => setShowAdvancedFilterPanel(!showAdvancedFilterPanel)}
				title="Filter"
				closeBtn>
				<AdvancedFilterPanel
					toggle={() => setShowAdvancedFilterPanel(!showAdvancedFilterPanel)}
					onSubmit={(values) => submitFilter(values)}
				/>
			</FilterPanel>
		</section>
	);
};

const mapStateToProps = (state) => {
	const { Exercises, UI } = state;
	return {
		exerciseList: get(Exercises, "exercisesResult.results", null),
		next: get(Exercises, "exercisesResult.next"),
		exercisesSearchKeyword: get(Exercises, "exercisesSearchKeyword", null),
		atBottom: UI.atBottom
	};
};

const mapDispatchToProps = {
	getExercises,
	resetField
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ExerciseListing);
